<template>
  <router-view />
</template>
<script>
import "./assets/css/main.css";

export default {
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style lang="stylus">
@media screen and (max-width: 1920px) {
    #app {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
}
@media screen and (min-width: 1920px) {
  #app {
    width: 19.2rem;
    margin: 0 auto;
    height: 100%;
    overflow: auto;
  }
}
@media screen and (min-width: 750px) {
  #app {
    width: 7.5rem;
    margin: 0 auto;
    height: 100%;
    overflow: auto;
  }
}
</style>
